import { Grid, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Loading from "../../loading";
import SimpleLineChart from "./lineChart";
import { styles } from "./styles";
import Toolbar from "./toolbar";

class OrderDashboard extends React.Component {
  fetchData = async (from, to, type) => {
    this.loading.startLoading();
    let check = await this.props.orderDispatch.statisticsOrder({
      from: moment(from).startOf("month").valueOf(),
      to: moment(to).endOf("month").valueOf(),
      type: type,
    });
    this.loading.stopLoading();
  };

  render() {
    const { classes, t } = this.props;
    const order = this.props.orderState.statistics;
    let data = [];
    let totalOrders = 0;

    order.map((element) => {
      data.push({
        name: moment([element._id.year, element._id.month - 1]).format(
          "MMM YYYY"
        ),
        Count: element.count,
      });
      totalOrders += element.count;
    });
    return (
      <div className={classes.containerPaper}>
        <Paper className={classes.root}>
          <Loading onRef={(id) => (this.loading = id)} />
          <Toolbar total={totalOrders} fetchData={this.fetchData} />
          <div className={classes.container}>
            <Grid container spacing={3}>
              <SimpleLineChart data={data} id="dashboard-orderchart" />
            </Grid>
          </div>
        </Paper>
      </div>
    );
  }
}

OrderDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  orderState: state.order,
});

const mapDispatch = (dispatch) => ({
  orderDispatch: dispatch.order,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(OrderDashboard)
  )
);
